if ($("#header").length) {
  loadFooter(customHeader, buildFooter);
  function customHeader() {
    document.addEventListener("ShoptetDOMSearchResultsLoaded", function () {
      if ($(".search-whisperer.active .search-whisperer-empty").length) {
        if (!$(".search-whisperer.active .search-whisperer-empty .notFound").length) {
          $(".search-whisperer.active  .search-whisperer-empty").append($("#footer .notFound").clone());
          $(".search-whisperer-empty .notFound .contactWrap").append($(".top-navigation-contacts").first().clone());
          $('<span class="close"></span>').appendTo(".search-whisperer .notFound");
        }
      }
      if ($(".search-whisperer.active:not(:has(.search-whisperer-empty))").length) {
        $(".search-whisperer.active").append($('#formSearchForm button[data-testid="searchBtn"]').clone().text("Prozkoumat produkty"));

        const $documents = $(".search-whisperer.active .search-whisperer-documents");

        if ($documents.length && !$documents.children(".categories, .blogs").length) {
          const $categoryLinks = $documents.find(".search-whisperer-category");
          const $blogLinks = $documents.find(".search-whisperer-document:not(.search-whisperer-category)");

          if ($categoryLinks.length) {
            $categoryLinks.wrapAll('<div class="categories"></div>');
            $(".search-whisperer .categories").prepend("<h4>Nalezeno v kategoriích</h4>");
          }

          if ($blogLinks.length) {
            $blogLinks.wrapAll('<div class="blogs"></div>');
            $(".search-whisperer .blogs").prepend("<h4>Nalezeno v článcích </h4>");
          }
        }
      }

      $(".notFound span.close").on("click", function () {
        $(".search-whisperer").removeClass("active");
        $('.search input[type="search"]').val("").trigger("input").trigger("change");
      });
    });

    $(".notFound span.close").on("click", function () {
      console.log("test");
      $(".search-whisperer").removeClass("active");
    });

    if ($("body").hasClass("mobile")) {
      $(".navigation-in.menu .navigationActions").before($(".top-navigation-contacts").first().clone());
      $(".navigation-in.menu .menu-level-1 ").after($(".top-navigation-bar .top-navigation-bar-menu").clone());
      $(".menu-item-1411 > a b").text(translation("jakZacitSeSvihadlem"));
      $(".menu-item-1378 > a b").text(translation("jakSiVybratSvihadlo"));
    }

    if (window.innerWidth < 992) {
      $(".btn.btn-icon.toggle-window.cart-count").removeAttr("data-hover");
      $(".btn.btn-icon.toggle-window.cart-count").removeAttr("data-target");
      $(".btn.btn-icon.toggle-window.cart-count").removeClass("toggle-window");
    }
    if (!$("#customerLogin .registrationBanner").length) {
      $("#customerLogin").append($("#footer .registrationBanner").clone());
    }

    $("#customerLogin #formLoginIncluded").prepend($("#login #loginHeading").clone().addClass("loginHeading"));
   $("#customerLogin input[type='email']").attr("placeholder", "Váš e-mail");
    $("#customerLogin input[type='password']").attr("placeholder", "Vaše heslo");
    $("#customerLogin .form-group:has(input[type='password'])").append($(".alternative-links").clone());

    $('<span class="close"></span>').appendTo(".login-widget .popup-widget-inner");
    $(document).on("click", ".login-widget .popup-widget-inner .close", function () {
      $("body").removeClass("user-action-visible login-window-visible");
    });

    $(".navigationActions").prepend($("footer#footer .lang"));
  }

  $(".menu-level-2 > li img").each(function () {
    const el = $(this);
    let img = el.attr("data-src");
    // console.log(img)
    if (img) {
      el.attr("data-src", img.replace("/thumb/", "/orig/"));
    }
  });
  $(".top-navigation-bar .top-navigation-tools .top-nav-button-login, .top-navigation-bar .top-navigation-tools .top-nav-button-account").prependTo("#header .navigation-buttons");

  $(".overall-wrapper > .user-action").appendTo("#header");

  $(function () {
    var $input = $("#header .search .form-control");
    if (!$input.length) return;

    $input.attr("placeholder", translation("hledat")).closest(".search").addClass("has-custom-placeholder");
  });

  if (!$("#cart-widget .emptyCart").length) {
    var cartInfo = getShoptetDataLayer("cartInfo");

    // if (!cartInfo || !cartInfo.freeShipping === false) {
    $("#footer .emptyCart .bottom").append(`
        <div id="freeShippingBox">
              <div id="freeShippingText">
                <p class="left">Nakup už <strong>jen za ${Number(freeShipping).ShoptetFormatAsCurrency()}</strong> a získej <strong>dopravu zdarma!</strong></p>
              </div>
              <div id="freeShippingBar">
                <span class="bar" style="width: 0%;"></span>
              </div>
              <span id="freeShippingAmounts">${Number(0).ShoptetFormatAsCurrency()} / <strong>${Number(freeShipping).ShoptetFormatAsCurrency()}</strong></span>
        </div>  
      `);
    //}

    if (!$("#footer .emptyCart .center .top-navigation-contacts").length) {
      $("#footer .emptyCart .center").append($(".top-navigation-contacts").first().clone());
    }

    $("#footer .emptyCart .center .top-navigation-contacts").prepend($("#footer .emptyCart .center p"));

    $("#cart-widget").append($("#footer .emptyCart"));
    $(".emptyCart .h5").append("<span class='close'></span>");
    $(".emptyCart .close").on("click", function () {
      $("body").removeClass("cart-window-visible");
      $("body").removeClass("user-action-visible");
    });
  }

  $(document).ready(function () {
    const $cartHoverArea = $('a[data-target="cart"]');

    $cartHoverArea.on("mouseenter", function () {
      shoptet.popups.showPopupWindow("cart", true);
    });
  });

  function checkCartState() {
    if (!$('a.cart-count i[data-testid="headerCartCount"]').length) {
      $("a.cart-count").append('<i data-testid="headerCartCount">0</i>');
    }

    const isFull = $('.cart-count i[data-testid="headerCartCount"]').text().trim() !== "0";
    $("#cart-widget").toggleClass("empty", !isFull);

    isFull ? "" : $(".cart-count .cart-price").text("0 Kč");

    $("#cart-widget .cart-widget-button a").text(translation("nakupniKosik"));

    if (!$(".cart-widget .cart-widget-button span#backToShop").length) {
      $("#cart-widget .cart-widget-button").append('<span id="backToShop">Zpět do obchodu</span>');
      $("#backToShop").on("click", function () {
        $("body").removeClass("cart-window-visible");
        $("body").removeClass("user-action-visible");
      });
    }
  }

  checkCartState();
  updateFreeShippingBox("#cart-widget");
  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    checkCartState();
    updateFreeShippingBox("#cart-widget");
  });
  document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    checkCartState();
    updateFreeShippingBox("#cart-widget");
  });
}

(function () {
  function updateCartWidgetFade() {
    const products = document.querySelector("#cart-widget:not(.empty) .cart-widget-products");

    if (!products) return;

    const hasOverflow = products.scrollHeight > products.clientHeight + 1;
    const isBottom = products.scrollTop + products.clientHeight >= products.scrollHeight - 2;

    products.classList.toggle("hasFade", hasOverflow && !isBottom);
    products.classList.toggle("isScrolledBottom", isBottom);
  }

  function initCartWidgetFade() {
    const products = document.querySelector("#cart-widget:not(.empty) .cart-widget-products");

    if (!products || products.dataset.fadeInitialized === "true") return;

    products.dataset.fadeInitialized = "true";

    products.addEventListener("scroll", updateCartWidgetFade, { passive: true });

    updateCartWidgetFade();
  }

  document.addEventListener("DOMContentLoaded", initCartWidgetFade);

  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    setTimeout(function () {
      initCartWidgetFade();
      updateCartWidgetFade();
    }, 100);
  });

  document.addEventListener("ShoptetCartUpdated", function () {
    setTimeout(function () {
      initCartWidgetFade();
      updateCartWidgetFade();
    }, 100);
  });

  window.addEventListener("resize", updateCartWidgetFade);
})();
